
import http from "infra/http";
import { useMutation } from "react-query";

export default function useDeleteFeriados() {
  return useMutation(
    async (id: string) => {

      const { data } = await http.delete(`/v1/feriado/${id}`);

      return data;
    },
  );
}
